<template>
    <div class="menu">
        <div @click="showDetails(item.localLng, item.localLat, index, item)">
            <div class="head">
                <p :title="item.name">{{ item.name }}</p>
                <span class="i-status">{{ item.distance }}</span>
                <!-- <span
                    class="i-statusTitle"
                    :style="{ background: getBackground(item.state) }"
                    >{{ item.state | dealStatus }}</span
                > -->
                <img src="" alt="">
                <img class="i-state" v-if='item.state === 1' src="../../../assets/jjzb.png"/>
                <img class="i-state" v-if='item.state === 2 || item.state === 6' src="../../../assets/zzzb.png"/>
                <img class="i-state" v-if='item.state === 3' src="../../../assets/jbpb.png"/>
                <img class="i-state" v-if='item.state === 4' src="../../../assets/zbdb.png"/>
                <img class="i-state" v-if='item.state === 8' src="../../../assets/zbyg.png"/>
                <img class="i-state" v-if='item.state === 9' src="../../../assets/zbbm.png"/>
            </div>
            <div class="detailBody">
                <p class="badge">
                    <span style="color: rgba(255, 0, 0, 0.847)" v-if="item.biddingMethod == 2"
                        >【邀请招标】</span
                    >
                    <span style="color: #409ee9" v-if="item.verticalTypeName"
                        >【{{ item.verticalTypeName }}】</span
                    >
                    <span style="color: #ff6600"
                        >【{{ item.type | tenderType }}】</span
                    >
                    <span style="color: #0286df"
                        v-if="item.rotation"
                    >【第{{ item.rotation }}轮】</span
                    >
                </p>
                <p class="address" v-if="item.money" :title="item.money + '元'">
                    <span>预算金额：</span>
                    {{ getMoney(item.money) }}
                </p>
                <p
                    class="company"
                    :title="item.introduce"
                    v-if="item.comNo"
                    @click.stop="toCompany(item.comNo)"
                >
                    <span>招标企业：</span>
                    {{ item.comName }}
                </p>
                <p class="company" :title="item.introduce" v-else>
                    <span>招标企业：</span>
                    {{ item.companyName }}
                </p>
                <p class="end-time" v-if="item.state == 9">
                    报名结束时间：
                    <span>{{ item.applyEndTime | formaHoures }}</span>
                </p>
                <p class="end-time" v-else-if="item.state == 1">
                    投标开始时间：
                    <span v-if="item.startTime">{{
                        item.startTime | formaHoures
                    }}</span>
                </p>
                <p class="end-time" v-else-if="item.state == 3">
                    竞标时间：
                    <span v-if="item.bidTime">{{
                        item.bidTime | formaHoures
                    }}</span>
                </p>
                <p class="end-time" v-else-if="item.state == 4">
                    定标时间：
                    <span v-if="item.winningTime">{{
                        item.winningTime | formaHoures
                    }}</span>
                </p>
                <p class="end-time" v-else-if="item.endTime">
                    投标结束时间：
                    <span>{{ item.endTime | formaHoures }}</span>
                </p>
                <p
                    class="end-time"
                    v-else-if="item.cancelTime && $route.path != '/direct-jb'"
                >
                    投标结束时间：
                    <span>{{ item.cancelTime | formaHoures }}</span>
                </p>
                <p class="end-time" v-else-if="$route.path == '/direct-jb'">
                    发布时间：
                    <span>{{ item.created | formaHoures }}</span>
                </p>
                <p class="end-time" v-else-if="item.bidTimeStr">
                    竞标开始时间：
                    <span>{{ item.bidTimeStr }}</span>
                </p>
                <p
                    class="address"
                    :title="item.bidAddress"
                    v-if="item.bidAddress && item.bidType !== 2"
                >
                    <span>竞标地点：</span>
                    {{ item.bidAddress }}
                </p>
                <p
                    class="address"
                    :title="item.bidMeetingPlatform + ':' + item.bidMeetingNo"
                    v-if="item.bidType === 2"
                >
                    <span>竞标平台：</span>
                    {{ item.bidMeetingPlatform }}：
                    {{ item.bidMeetingNo }}
                </p>
                <p
                    class="address"
                    :title="item.region"
                    v-if="item.region && !item.bidAddress"
                >
                    <span>地址：</span>
                    {{ item.region }}
                </p>
            </div>
            <jPop
                :item="item"
                @go="goNewDetail(item.id)"
                @inByLetDialogClick="inByLetDialogClick"
            ></jPop>
            <InByLetDialog
                :dialogVisible="inByLetDialogShow"
                :dialogType="0"
                :typeData="typeData"
                @closeDialog="closeinDialog"
                @confirmDialog="confirminDialog"
            ></InByLetDialog>
        </div>
    </div>
</template>

<script>
import apiIln from '@/api/zhaocai/apiLnquiryLetter.js'
import link from '@/public/link.js'

export default {
  data () {
    return {
      inByLetDialogShow: false,
      typeData: []
    }
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    index: {
      type: Number
    },
    isList: {
      type: Boolean
    }
  },
  created () {},
  mounted () {
    this.$forceUpdate()
  },
  components: {
    jPop: () => import('@/components/zhaocai/jPop'),
    InByLetDialog: () => import('@/components/zhaocai/InquiryLetterDialog')
  },
  methods: {
    // 函询dialog关闭方法
    closeinDialog (val) {
      this.inByLetDialogShow = val
    },
    async confirminDialog (obj, cab) {
      let data = { markId: this.jMarkId, ...obj }
      let res = await apiIln.getSaveForTender(data)
      if (res.data.code == 0) {
        this.$message.success(res.data.msg)
        this.inByLetDialogShow = false
      } else {
        this.$message.error(res.data.msg)
      }
      cab()
    },
    toCompany (no) {
      link.materialsShopUrl(no, 10)
    },
    getMoney (val) {
      if (val >= 10000) {
        return (
          (val / 10000).toString().match(/^\d+(?:\.\d{0,2})?/) +
                    '万元'
        )
      } else {
        return val + '元'
      }
    },
    getBackground (status) {
      let str = ''
      switch (status) {
        case 1:
          str = '#F7AB01'
          break
        case 2:
          str = '#0286DF'
          break
        case 3:
          str = '#78C06E'
          break
        case 4:
          str = '#969696'
          break
        case 5:
          str = '#969696'
          break
        case 6:
          str = '#78C06E'
          break
        case 9:
          str = '#409EE9'
          break
        case 10:
          str = '#F7AB01'
          break
        default:
          str = '#969696'
          break
      }
      return str
    },
    // 函询
    async inByLetDialogClick (e, s, obj) {
      if (this.$store.state.loginType) {
        let res = {}
        if (s == 0) {
          res = await apiIln.getCheckAllowBidQuestion(e)
        } else {
          res = await apiIln.getCheckAllowTenderQuestion(e)
        }

        if (res.data.code == 0) {
          this.getTenderReceiverInquiry(obj.type)
          this.inByLetDialogShow = true
        } else {
          this.$message.error(res.data.msg)
        }
      } else {
        // 没有登录
        this.$store.commit('SET_LOGINDIALOG', true)
        return false
      }
    },
    goNewDetail (no) {
      window.open(`${process.env.VUE_APP_ZHAOCAI}/hotTenderMachineLaborDetail?no=${no}`)
    },
    showDetails (e, twoE, index, item = {}) {
      if (this.isList) {
        this.$emit('showDetails', e, twoE, index)
      } else {
        this.goNewDetail(item.id)
      }
    },
    async getTenderReceiverInquiry (type) {
      let pararms = {
        tenderingType: type
      }
      let { data } = await apiIln.getTenderReceiverInquiry(pararms)
      if (data.code === 0) {
        this.typeData = data.result
      }
    }
  },
  filters: {
    dealStatus (status) {
      // 招标状态
      let str = ''
      switch (status) {
        case 1:
          str = '待招标'
          break
        case 2:
          str = '招标中'
          break
        case 3:
          str = '评标中'
          break
        case 4:
          str = '招标结束'
          break
        case 5:
          str = '废标'
          break
        case 6:
          str = '评标中'
          break
        case 8:
          str = '待报名'
          break
        case 9:
          str = '报名中'
          break
        case 10:
          str = '资格审查中'
          break
        default:
          break
      }
      return str
    },
    direct (status) {
      let str = ''
      switch (status) {
        case 1:
          str = '草稿'
          break
        case 2:
          str = '竞价中'
          break
        case 3:
          str = '已结束'
          break
        case 4:
          str = '已取消'
          break
        default:
          break
      }
      return str
    },
    showStatus (status) {
      // 招标状态
      let str = ''
      switch (status) {
        case 3:
          str = '招标结束'
          break
        case 8:
          str = '待报名'
          break
        case 9:
          str = '报名中'
          break
        case 10:
          str = '资格审查中'
          break
        default:
          str = '招标中'
          break
      }
      return str
    }
  }
}
</script>

<style scoped lang="scss">
.menu {
    width: 275px;
    background-color: #fff;
    border: 1px solid #e4e7ed;
    margin-top: 25px;
    margin-left: 20px;
    cursor: pointer;
    height: 284px;
    .head {
        height: 70px;
        background-color: #f5f7fa;
        position: relative;
        border-bottom: 1px solid #e4e7ed;
        overflow: hidden;
        p {
            width: 220px;
            height: 50px;
            line-height: 25px;
            padding-top: 10px;
            margin-left: 10px;
            font-size: 16px;
            color: #333;
            font-weight: normal;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
        }
        .i-status {
            display: block;
            position: absolute;
            top: 37px;
            right: -15px;
            font-size: 12px;
            color: #0286df;
            width: 90px;
            height: 24px;
            line-height: 24px;
            text-align: center;
            transform-origin: (0, 0);
        }
        .blue {
            background-color: #409ee9;
        }
    }
    .detailBody {
        padding: 15px 12px;
        font-size: 14px;
        .badge {
            // display: flex;
            white-space: nowrap;
            span {
                font-size: 13px;
                display: inline-block;
                &:first-child {
                    // margin-right: 2px;
                    color: #ff6600;
                }
            }
            .moeny {
                flex: 1;
                display: inline-block;
                text-align: right;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
        .end-time {
            color: #666;
            margin-top: 12px;
            span {
                color: #969696;
            }
        }
        .company {
            margin-top: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #0286df;
            span {
                color: #666;
            }
        }
        .address {
            margin-top: 12px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            color: #969696;
            span {
                color: #666;
            }
        }
    }
}
.i-state{
    display: block;
    position: absolute;
    top: -6px;
    right: -7px;
}
.i-statusTitle {
    display: block;
    position: absolute;
    top: 9px;
    right: -25px;
    font-size: 12px;
    color: #fff;
    background-color: #999;
    width: 90px;
    height: 24px;
    line-height: 24px;
    text-align: center;
    transform: rotate(45deg);
    transform-origin: (0, 0);
}
</style>
